const WebsiteDevelopment  = {
  "heroQuoteSection": {
      "enable": true,
      "title": "UI/UX DESIGNING",
      "headline": "<strong>strategic brand communication</strong> with custom web design",
      "image": require('../images/ui-ux/ui_img-1.png'),
      "position": "center", //center, left or rightM
      "btnGrad" : "blue",
      "class": "move-from-left"
  },
  "textWithImage":{
    "enable": true,
    "content": "Crafting visual communications that delight, captivate & leaves a lasting impression on your audience.",
    "image": require('../images/ui-ux/ui_img-2.png'),
    "position": "", //center, left or rightM
    "class": "bounce-up-down"
  },  
  "headingWithGrid":{
    "enable": true,
    "title": "We are experts in",
    "blocks": [
      {
        "src": require('../images/ui-ux/wireframe-designing.png'),
        "title": "WIREFRAME DESIGNING",
        "url": "e-commerce/seo"
      },
      {
        "src": require('../images/ui-ux/brand-logo.png'),
        "title": "BRAND LOGO DESIGN",
        "url": "e-commerce/smm"
      },
      {
        "src": require('../images/ui-ux/ui-ux-interface.png'),
        "title": "UI/UX INTERFACE",
        "url": "e-commerce/ppc"
      },
      {
        "src": require('../images/ui-ux/motion-design.png'),
        "title": "MOTION DESIGN",
        "url": "e-commerce/analytics"
      }
    ]
  },
  "faq":{
    "enable": true,
    "title": "Frequently asked questions",
    "questions": [
      {
        "key": 1,
        "q": "What is Responsive Web Design?",
        "a": "As the name suggests, responsive web design refers to a webpage that is quick to load and respond when any action is taken. This is key to creating an engaging user experience that allows the user to browse through the website and it’s various features smoothly without any unnecessary delays.<br/><br/>In the modern world, web design is not restricted to a quick and responsive desktop website. Today, a webpage has to be fully optimized for mobile and tablet devices too. This is where the challenge really comes in. The design, pixels, graphics and resolutions all need to be adjusted according to the platform that will host the web page. This is where the need for a professional web design agency is comes in."
      },
      {
        "key": 2,
        "q": "What is Custom Website Design?",
        "a": "Custom web design refers to creating a web page that has been custom made to fit the unique requirements of any brand, individual or topic. Every company has a different vision for themselves and it is key to the long-term success of any brand, that their vision and style is incorporated onto their websites. Afterall, a brands website is the most direct point of interaction between customers and the brands products, services and vision.<br /><br/>Custom web design aims to bring in design elements and features that are unique to the brand and can’t be found elsewhere. The type of design depends on the type of brand. Some brands look for flamboyance, some for simplicity and some for usability. Don’t take our word for it. Have a look at our portfolio here."
      },
      {
        "key": 3,
        "q": "What is the web design process followed by design agencies?",
        "a": `The key to nailing the web design is communication between the web design company and the brand in question. Only once the client’s vision has been communicated and understood, can the web design company begin to list out what can and what can’t be done. Listed below are the basic steps followed in web design – <br/><br/>
        <ul class="default">
        <li>Goal Identification</li>
        <li>Scope Definition</li>
        <li>Sitemap and Wireframe Creation</li>
        <li>Content Creation</li>
        <li>Visual Elements</li>
        <li>Testing</li>
        <li>Launch</li>
        </ul>
        
        `
      }
    ]
  }
};

export default WebsiteDevelopment;